'use client'

import React from "react";
import { IMaskInput } from "react-imask"

interface PhoneMaskInputProps {
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PhoneMaskInput = React.forwardRef<HTMLInputElement, PhoneMaskInputProps>(
  function PhoneMaskInput(props, ref) {
    const { onChange, name, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask="+{0}#########################"
        definitions={{
          "#": /[0-9]/,
        }}
        overwrite={false}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({
            target: { name, value },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
      />
    );
  }
);